import React from 'react'
import Window from '@/components/ui/window'

type QuoteProps = {
    id?: string;
}


const Quotes: React.FC<QuoteProps> = (props): JSX.Element => {

    return (
        <div className="min-h-screen">
            <Window content={<><div>how are you.</div></>} key={`quotetationid`} />
        </div>
    )
};

export default Quotes;
